module.exports = __webpack_public_path__ + "img/04012900.f2209f04.png";